import React from "react";
import { motion } from "framer-motion";
import ProgressBar from "./ProgressBar";
import { useSkills } from "./useResumeData";

const pageTransitionVariants = {
  hidden: {
    x: "100vw",
    opacity: 0,
  },
  visible: {
    x: 0,
    opacity: 1,
    transition: {
      // delay: 0.2,
      duration: 0.6,

      when: "beforeChildren",
      staggerChildren: 0.4,
    },
  },
  exit: {
    x: "-100vw",
  },
};
const Skills = () => {
  const { skills, isLoading } = useSkills();

  return (
    <motion.div
      variants={pageTransitionVariants}
      initial="hidden"
      animate="visible"
      className=" pb-16 px-2 sm:px-8"
    >
      <div className=" font-primary text-gray-500 dark:text-lightText text-center my-4 md:my-12">
        <p
          className=" text-designColor opacity-95 mt-10
         tracking-widest"
        >
          Features
        </p>
        <h2 className=" text-2xl sm:text-4xl capitalize font-bold mb-12">
          Development skills
        </h2>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-x-16 gap-y-8">
        {isLoading ? (
          // Simple Skeleton
          [1, 2, 3, 4].map((i) => (
            <div key={i} className="animate-pulse h-8 rounded bg-gray-200 dark:bg-[#1a1f2e]"></div>
          ))
        ) : (
          skills?.map((item) => (
            <ProgressBar
              key={item.id}
              title={item.name}
              percentage={`${item.percentage}%`}
            />
          ))
        )}
      </div>
    </motion.div>
  );
};

export default Skills;
